import _classCallCheck from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */

/**
 * A ring buffer, providing O(1) FIFO, LIFO, and related operations.
 */
export var RingBuffer = /*#__PURE__*/function () {
  /**
   * Constructs a `RingBuffer`.
   * @param capacity The number of items that the buffer can accomodate.
   */
  function RingBuffer(capacity) {
    _classCallCheck(this, RingBuffer);

    this.capacity = capacity; // Note we store the indices in the range 0 <= index < 2*capacity.
    // This allows us to distinguish the full from the empty case.
    // See https://www.snellman.net/blog/archive/2016-12-13-ring-buffers/

    this.begin = 0; // inclusive

    this.end = 0; // exclusive

    if (capacity == null) {
      throw new RangeError('Can\'t create a ring buffer of unknown capacity.');
    }

    if (capacity < 1) {
      throw new RangeError('Can\'t create ring buffer of capacity < 1.');
    }

    this.data = new Array(capacity);
    this.doubledCapacity = 2 * capacity;
  }
  /**
   * Map any index into the range 0 <= index < 2*capacity.
   */


  _createClass(RingBuffer, [{
    key: "wrap",
    value: function wrap(index) {
      // don't trust % on negative numbers
      while (index < 0) {
        index += this.doubledCapacity;
      }

      return index % this.doubledCapacity;
    }
  }, {
    key: "get",
    value: function get(index) {
      if (index < 0) {
        throw new RangeError('Can\'t get item at a negative index.');
      }

      return this.data[index % this.capacity];
    }
  }, {
    key: "set",
    value: function set(index, value) {
      if (index < 0) {
        throw new RangeError('Can\'t set item at a negative index.');
      }

      this.data[index % this.capacity] = value;
    }
    /**
     * Returns the current number of items in the buffer.
     */

  }, {
    key: "length",
    value: function length() {
      var length = this.end - this.begin;

      if (length < 0) {
        length = this.doubledCapacity + length;
      }

      return length;
    }
    /**
     * Reports whether the buffer is full.
     * @returns true if the number of items in the buffer equals its capacity, and
     *   false otherwise.
     */

  }, {
    key: "isFull",
    value: function isFull() {
      return this.length() === this.capacity;
    }
    /**
     * Reports whether the buffer is empty.
     * @returns true if the number of items in the buffer equals zero, and
     *   false otherwise.
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.length() === 0;
    }
    /**
     * Adds an item to the end of the buffer.
     */

  }, {
    key: "push",
    value: function push(value) {
      if (this.isFull()) {
        throw new RangeError('Ring buffer is full.');
      }

      this.set(this.end, value);
      this.end = this.wrap(this.end + 1);
    }
    /**
     * Adds many items to the end of the buffer, in order.
     */

  }, {
    key: "pushAll",
    value: function pushAll(values) {
      var _iterator = _createForOfIteratorHelper(values),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          this.push(value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Removes and returns the last item in the buffer.
     */

  }, {
    key: "pop",
    value: function pop() {
      if (this.isEmpty()) {
        throw new RangeError('Ring buffer is empty.');
      }

      this.end = this.wrap(this.end - 1);
      var result = this.get(this.end);
      this.set(this.end, undefined);
      return result;
    }
    /**
     * Adds an item to the beginning of the buffer.
     */

  }, {
    key: "unshift",
    value: function unshift(value) {
      if (this.isFull()) {
        throw new RangeError('Ring buffer is full.');
      }

      this.begin = this.wrap(this.begin - 1);
      this.set(this.begin, value);
    }
    /**
     * Removes and returns the first item in the buffer.
     */

  }, {
    key: "shift",
    value: function shift() {
      if (this.isEmpty()) {
        throw new RangeError('Ring buffer is empty.');
      }

      var result = this.get(this.begin);
      this.set(this.begin, undefined);
      this.begin = this.wrap(this.begin + 1);
      return result;
    }
    /**
     * Removes and returns a specific item in the buffer, and moves the last item
     * to the vacated slot.  This is useful for implementing a shuffling stream.
     * Note that this operation necessarily scrambles the original order.
     *
     * @param relativeIndex: the index of the item to remove, relative to the
     *   first item in the buffer (e.g., hiding the ring nature of the underlying
     *   storage).
     */

  }, {
    key: "shuffleExcise",
    value: function shuffleExcise(relativeIndex) {
      if (this.isEmpty()) {
        throw new RangeError('Ring buffer is empty.');
      }

      var index = this.wrap(this.begin + relativeIndex);
      var result = this.get(index);
      this.set(index, this.pop());
      return result;
    }
  }]);

  return RingBuffer;
}();